import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';

import { DataService } from '../../../services/data.service';
import { LocaleService } from '../../../services/locale.service';
import { Person, AnagraficaDettaglioParameter } from '../../../models/person';

@Component({
  selector: 'app-anagrafica-dettaglio',
  templateUrl: './anagrafica-dettaglio.component.html',
  styleUrls: ['./anagrafica-dettaglio.component.css']
})
export class AnagraficaDettaglioComponent implements OnInit {
	@ViewChild('anagrafica') anagrafica: any;
	@Input() person: any;
	@Input() writePermission: boolean = false;
	@Output() innerEvents = new EventEmitter();
	newPerson: boolean = false;

	anagraficaDettaglioParameter: AnagraficaDettaglioParameter = null;

	constructor(private dataService: DataService){
	}

	ngOnInit() {
    if(!this.anagraficaDettaglioParameter){
		  this.anagraficaDettaglioParameter = new AnagraficaDettaglioParameter(this.person.anagrafica_id, "big", this.writePermission);
    }
		if (!this.newPerson && this.person != 'new') {
			this.reset();
		}
		console.log("CMP|ANAGRAFICA-DETTAGLIO - INIT:", this.writePermission, this.anagraficaDettaglioParameter);
	}

	ngOnChanges(changes: any){
		console.debug('ANAGRAFICA-DETTAGLIO|CHANGE', changes);
		if(changes.person){
			if (this.person.anagrafica_id && this.person.anagrafica_id > 0){
				//console.debug('ANAGRAFICA-DETTAGLIO|CASE A', this.person.anagrafica_id);
				let person: any = this.dataService.getPersonById(this.person.anagrafica_id, (person) => {
					//console.debug('ANAGRAFICA-DETTAGLIO|CASE A person:', person);
					if(person){
						this.person = person;
						//console.debug('ANAGRAFICA-DETTAGLIO|CASE A1', this.person);
					}
					else {
						this.person = new Person(this.person.anagrafica_id);
						//console.debug('ANAGRAFICA-DETTAGLIO|CASE A2', this.person);
					}
					this.person.societa = Boolean(Number(this.person.societa));
					this.person.in_vita = Boolean(Number(this.person.in_vita));
				});
			}
			else if(!(this.person.anagrafica_id > 0)){
				console.debug('ANAGRAFICA-DETTAGLIO|CASE B', this.person.anagrafica_id);
				this.newAnagrafica();
			}
      if(!this.anagraficaDettaglioParameter){
        this.anagraficaDettaglioParameter = new AnagraficaDettaglioParameter(this.person.anagrafica_id, "big", this.writePermission);
      }
      console.debug('CMP|ANAGRAFICA-DETTAGLIO - person', this.person, "anagraficaDettaglioParameter", this.anagraficaDettaglioParameter);
		  this.anagraficaDettaglioParameter.setIdPerson(this.person.anagrafica_id);
    }
		console.log("writePermission", this.writePermission);
	}

	edit(){
		this.anagrafica.editable = !this.anagrafica.editable;
	}

	discard(){
		if(!this.newPerson){
			this.anagrafica.discard();
		}
		this.anagrafica.editable = false;
	}

	commit(){
    //console.log("CMP|anagrafica-dettaglio - commint", this.newPerson, this.anagrafica);
		if(this.newPerson){
			this.anagrafica.insert();
		}else{
			this.anagrafica.update();
		}
		this.anagrafica.editable = false;
		this.anagrafica.discard();
	}

	removePermitted(anagrafica: any){
		let result = this.newPerson || this.dataService.removePermitted(anagrafica);
		//console.log("removePermitted", anagrafica, result)
		return result;
	}

	remove(){
		this.anagrafica.remove();
		this.anagrafica.editable = false;
		this.hide();
	}

	newAnagrafica(){
		this.person = new Person();
		this.newPerson = true;
		this.anagrafica.editable = true;
	}

	calcTabIndexButton(condition){
		//console.log("calcTabIndex disabled", condition);
		if(condition){
			return -1;
		}else{
			return 0;
		}
	}

	calcTabIndex(){
		if(this.person.anagrafica_id){
			return 0;
		}else{
			return -1;
		}
	}

	getInnerEvents(event: any) {
		this.innerEvents.emit(event);
	}

	tornaIndietro(){
		let event: any = {
			resetState: true,
			hide : true,
		}
		this.getInnerEvents(event);
	}

	hide(){
		let event: any = {
			hide : true
		}
		this.getInnerEvents(event);
	}

	reset(){
		//console.debug("ANAGRAFICA-DETTAGLIO|RESET");
		this.anagrafica.editable = false;
		this.newPerson = false;
	}
}
